import React from 'react'

import Script from 'dangerous-html/react'

import './footer.css'

const Footer = (props) => {
  return (
    <div className="footer-container1">
      <footer className="footer-root">
        <div className="footer-container">
          <div className="footer-grid">
            <div className="footer-brand footer-column">
              <div className="footer-logo-wrapper">
                <img
                  src="/images/logo.png"
                  alt="Panda Demolition & Disposal"
                  className="footer-logo-img"
                />
              </div>
              <p className="footer-description section-content">
                {' '}
                Professional demolition and disposal solutions. We provide
                efficient dumpster rentals and large-scale project clearing with
                an industrial edge.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </p>
              <div className="footer-social-group">
                <a href="https://www.facebook.com/profile.php?id=61580931815926" target="_blank" rel="noopener noreferrer">
                  <div aria-label="Facebook" className="footer-social-link">
                    <svg
                      fill="none"
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      stroke="currentColor"
                      viewbox="0 0 24 24"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
                    </svg>
                  </div>
                </a>
              </div>
            </div>
            <nav className="footer-column">
              <h2 className="section-subtitle footer-heading">Navigation</h2>
              <ul className="footer-link-list">
                <li>
                  <a href="/">
                    <div className="footer-link">
                      <span>Home</span>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="/about-us">
                    <div className="footer-link">
                      <span>About Us</span>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="/services">
                    <div className="footer-link">
                      <span>Our Services</span>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="/contact">
                    <div className="footer-link">
                      <span>Contact Us</span>
                    </div>
                  </a>
                </li>
                <li>
                  <button onClick={() => window.openIframeModal('https://app.icans.ai/customer-portal/panda-demolition/auth/login/')} className="navigation-btn-reset navigation-mobile-btn-full">
                    <div className="footer-link">
                      <span>Customer Portal</span>
                    </div>
                  </button>
                </li>
              </ul>
            </nav>
            <nav className="footer-column">
              <h2 className="section-subtitle footer-heading">Services</h2>
              <ul className="footer-link-list">
                <li>
                  <a href="/dumpster-rental">
                    <div className="footer-link">
                      <span>Dumpster Rental</span>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="/rfq-portal">
                    <div className="footer-link">
                      <span>Request a Quote</span>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="/services">
                    <div className="footer-link">
                      <span>Residential Demolition</span>
                    </div>
                  </a>
                </li>
                <li>
                  <a href="/services">
                    <div className="footer-link">
                      <span>Commercial Disposal</span>
                    </div>
                  </a>
                </li>
                <li>
                  <button onClick={() => window.openIframeModal('https://app.icans.ai/customer-portal/panda-demolition/book/')} className="navigation-btn-reset navigation-mobile-btn-full">
                    <div className="footer-link">
                      <span>Book a Dumpster</span>
                    </div>
                  </button>
                </li>
              </ul>
            </nav>
            <div className="footer-column">
              <h2 className="section-subtitle footer-heading">Get In Touch</h2>
              <div className="footer-contact-info">
                <div className="footer-contact-item">
                  <svg
                    fill="none"
                    width="18"
                    xmlns="http://www.w3.org/2000/svg"
                    height="18"
                    stroke="currentColor"
                    viewbox="0 0 24 24"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="footer-contact-icon"
                  >
                    <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                    <circle r="3" cx="12" cy="10"></circle>
                  </svg>
                  <span className="section-content">
                    4233 W. Hillsboro Blvd #970092, Coconut Creek, FL 33097
                  </span>
                </div>
                <div className="footer-contact-item">
                  <svg
                    fill="none"
                    width="18"
                    xmlns="http://www.w3.org/2000/svg"
                    height="18"
                    stroke="currentColor"
                    viewbox="0 0 24 24"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="footer-contact-icon"
                  >
                    <path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233a14 14 0 0 0 6.392 6.384"></path>
                  </svg>
                  <a href="tel:+19544081674" className="section-content footer-contact-link">(954) 408-1674</a>
                </div>
                <div className="footer-contact-item">
                  <svg
                    fill="none"
                    width="18"
                    xmlns="http://www.w3.org/2000/svg"
                    height="18"
                    stroke="currentColor"
                    viewbox="0 0 24 24"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="footer-contact-icon"
                  >
                    <rect x="2" y="4" rx="2" width="20" height="16"></rect>
                    <path d="m22 7-8.99 5.73a2 2 0 0 1-2.01 0L2 7"></path>
                  </svg>
                  <a href="mailto:dispatch@pandademolition.com" className="section-content footer-contact-link">
                    dispatch@pandademolition.com
                  </a>
                </div>
              </div>
              <div className="footer-cta-wrapper">
                <button onClick={() => window.openIframeModal('https://app.icans.ai/customer-portal/panda-demolition/book/')} className="navigation-btn-reset">
                  <div className="btn-primary btn footer-cta-btn btn-sm">
                    <span>Book a Dumpster</span>
                  </div>
                </button>
              </div>
            </div>
          </div>
          <div className="footer-bottom">
            <div className="footer-copyright">
              <span>
                {' '}
                © 2026 Panda Demolition &amp; Disposal. All rights reserved.
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
            </div>
            <div className="footer-legal-links">
              <a href="/contact">
                <div className="footer-legal-link">
                  <span>Privacy Policy</span>
                </div>
              </a>
              <a href="/contact">
                <div className="footer-legal-link">
                  <span>Terms of Service</span>
                </div>
              </a>
              <a href="/contact">
                <div className="footer-legal-link">
                  <span>Sitemap</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </footer>
      <div className="footer-container2">
        <div className="footer-container3">
          <Script
            html={`<script defer data-name="footer-interactivity">
(function(){
  /* 
    Panda Demolition Footer Logic
    Ensures accessibility and subtle hover enhancements 
  */
  const footerLinks = document.querySelectorAll('.footer-link, .footer-social-link');
  
  footerLinks.forEach(link => {
    link.addEventListener('mouseenter', () => {
      // Subtle haptic-like visual feedback handled by CSS transitions
    });
  });

  // Current year auto-update (if copyright text was dynamic)
  const copyrightElement = document.querySelector('.footer-copyright');
  if (copyrightElement) {
    const currentYear = new Date().getFullYear();
    const text = copyrightElement.innerHTML;
    if (text.includes('2026')) {
      copyrightElement.innerHTML = text.replace('2026', currentYear);
    }
  }
})()
</script>`}
          ></Script>
        </div>
      </div>
    </div>
  )
}

export default Footer
